import { useAtomValue } from 'jotai'
import React from 'react'

import { hiddenBrandIdsAtom } from '../atoms'

import { useCurrentSurveyGroup } from './useCurrentSurveyGroup'

export const useVisibleBrands = () => {
  const surveyGroup = useCurrentSurveyGroup()
  const hiddenBrandIds = useAtomValue(hiddenBrandIdsAtom)

  return React.useMemo(
    () =>
      surveyGroup.brands.filter((brand) => !hiddenBrandIds.includes(brand.id)),
    [hiddenBrandIds, surveyGroup.brands],
  )
}
